import { ITeamManagement } from "../../models/TeamManagement";

export interface teamData {
    branch?: string,
    branch_ID?: number,
    company?: string,
    company_ID?: number,
    team_ID?: number,
    team_Manager?: string,
    team_Manager_ID?: number,
    team_Name?: string
}

export const EmptyTeam : ITeamManagement = {
    Team_Name: "",
    Company_Name: 0,
    Branch_Name: 0,
    TeamManagerid: 0
}

export const TeamData: teamData = {
    branch: "",
    branch_ID: 0,
    company: "",
    company_ID: 0,
    team_ID: 0,
    team_Manager: "",
    team_Manager_ID: 0,
    team_Name: ""
}